import React from 'react';
import { useHistory } from 'react-router-dom';

import HeaderTopic from '../../partials/HeaderTopic';
import PrimaryButton from '../../partials/PrimaryButton';
import srcWhistle from '../../graphics/images/whistle.png';

import styles from './NotFound.module.css';

function NotFound() {
  const history = useHistory();


  return (
    <div className={styles.wrapper}>
      <HeaderTopic topic="שגיאה 404" />
      <div className={styles.bgVisual}></div>
      <div className={styles.content}>
        <div className={styles.errorCode}>404</div>
        <h2 className={styles.errorHeader}>הדף שחיפשת לא נמצא</h2>
        <img src={srcWhistle} alt="שופר" className={styles.whistleImg} />
        <PrimaryButton
          onClick={() => history.push('/leagues')}
          size="large"
          text="חזרה לבית"
        />
      </div>
    </div>
  );
}

export default NotFound;

